package essntl.key

import androidx.compose.runtime.staticCompositionLocalOf

internal val LocalKeyEventManager = staticCompositionLocalOf { KeyEventManager() }